import type { CheckInViewSettings } from "./checkinView";
import { defaultCheckInViewSettings } from "./checkinView";

const DEFAULT_KEY = "m1member.checkin.view.default";
const userKey = (accountId: string) => `m1member.checkin.view.user.${accountId}`;

function safeParse(raw: string | null): CheckInViewSettings | null {
  if (!raw) return null;
  try {
    return JSON.parse(raw) as CheckInViewSettings;
  } catch {
    return null;
  }
}

export function loadCheckInView(accountId?: string | null): CheckInViewSettings {
  if (accountId) {
    const u = safeParse(localStorage.getItem(userKey(accountId)));
    if (u) return { ...defaultCheckInViewSettings, ...u };
  }
  const d = safeParse(localStorage.getItem(DEFAULT_KEY));
  return { ...defaultCheckInViewSettings, ...(d ?? {}) };
}

export function saveCheckInView(settings: CheckInViewSettings, accountId?: string | null) {
  const raw = JSON.stringify(settings);
  if (accountId) localStorage.setItem(userKey(accountId), raw);
  else localStorage.setItem(DEFAULT_KEY, raw);
}




















